import { getEndpointsForEnv } from "@oneapp/data";
let configuredOneGeniusUrlGetter = null;
let configuredModuleEnvGetter = null;
/**
 * Read Vite `import.meta.env` without a direct `import.meta` reference.
 * Hermes throws SyntaxError on bare `import.meta` even inside try/catch.
 */
function readViteEnv() {
    try {
        const readMeta = new Function("try { return import.meta && import.meta.env; } catch (e) { return undefined; }");
        return readMeta();
    }
    catch {
        return undefined;
    }
}
function firstNonEmpty(...values) {
    for (const value of values) {
        const trimmed = typeof value === "string" ? value.trim() : "";
        if (trimmed)
            return trimmed;
    }
    return undefined;
}
/**
 * Prefer static `process.env.X` keys so RN babel inline can replace them.
 * Do not use NODE_ENV — Vite staging builds also set NODE_ENV=production.
 */
function readProcessBranchEnv() {
    if (typeof process === "undefined")
        return undefined;
    return firstNonEmpty(process.env?.BRANCH, process.env?.ENVIRONMENT, process.env?.ENV, process.env?.VITE_SENTRY_ENV);
}
export function readBranchEnv() {
    const fromInit = firstNonEmpty(configuredModuleEnvGetter?.());
    if (fromInit)
        return fromInit;
    const vite = readViteEnv();
    // MODE is always set by Vite (--mode). Prefer it over VITE_SENTRY_ENV
    // (preprod .env sets VITE_SENTRY_ENV=development).
    const fromVite = firstNonEmpty(vite?.BRANCH, vite?.MODE, vite?.VITE_SENTRY_ENV);
    if (fromVite)
        return fromVite;
    return readProcessBranchEnv();
}
/** Called from `SqsEvents.init` so host apps can pass env-resolved Genius URL / branch. */
export function configureOneGeniusApiBaseUrl(options) {
    configuredOneGeniusUrlGetter = options.getOneGeniusApiBaseUrl ?? null;
    configuredModuleEnvGetter = options.getModuleEnv ?? null;
}
/** Resolve One Genius API host without registering a multi-API client. */
export function getOneGeniusApiBaseUrl() {
    // 1) Host app explicit env (web VITE_ONE_GENIUS / mobile ONE_GENIUS via init)
    const fromInit = firstNonEmpty(configuredOneGeniusUrlGetter?.());
    if (fromInit)
        return fromInit.replace(/\/+$/, "");
    // 2) Direct env reads (RN babel inline / Vite when import.meta is readable)
    const explicit = firstNonEmpty(readViteEnv()?.VITE_ONE_GENIUS, typeof process !== "undefined" ? process.env?.ONE_GENIUS : undefined, typeof process !== "undefined" ? process.env?.VITE_ONE_GENIUS : undefined);
    if (explicit)
        return explicit.replace(/\/+$/, "");
    return getEndpointsForEnv(readBranchEnv()).oneGenius.replace(/\/+$/, "");
}
export function getGatewayProductId() {
    return (firstNonEmpty(readViteEnv()?.VITE_PRODUCT_ID, typeof process !== "undefined" ? process.env?.PRODUCT_ID : undefined, typeof process !== "undefined" ? process.env?.VITE_PRODUCT_ID : undefined) ?? "300");
}
export function getGatewayTenantId() {
    return (firstNonEmpty(readViteEnv()?.VITE_TENANT_ID, typeof process !== "undefined" ? process.env?.TENANT_ID : undefined, typeof process !== "undefined" ? process.env?.VITE_TENANT_ID : undefined) ?? "1");
}
/** Resolve Learn Gateway host from env or `@oneapp/data` endpoints map. */
export function getLearnGatewayApiBaseUrl() {
    const explicit = firstNonEmpty(readViteEnv()?.VITE_LEARN_GATEWAY, typeof process !== "undefined" ? process.env?.LEARN_GATEWAY : undefined, typeof process !== "undefined" ? process.env?.VITE_LEARN_GATEWAY : undefined);
    if (explicit)
        return explicit.replace(/\/+$/, "");
    return getEndpointsForEnv(readBranchEnv()).learnGateway.replace(/\/+$/, "");
}
